import FarmTypeLabel from './FarmTypeLabel';

export default FarmTypeLabel;
